import { Component, Input, OnInit } from '@angular/core';
import { ITableCell } from 'src/app/shared/models/table-cell';
import { ZoningCode, ZoningCodeVersion } from '../../models';

@Component({
    standalone: false,
    selector: 'app-zoning-code-versions-list',
    templateUrl: './zoning-code-versions-list.component.html',
    styleUrls: ['./zoning-code-versions-list.component.scss']
})
export class ZoningCodeVersionsListComponent implements OnInit {
    @Input()
    zoningCode: ZoningCode;

    @Input()
    zoningCodeVersionSelectionHandler: (zoningCode: ZoningCode, zoningCodeVersion: ZoningCodeVersion) => void;

    @Input()
    showActions: boolean = true;

    @Input()
    showStatusColumn: boolean = true;

    @Input()
    setIsLoadedZCVersionDialogHandler: (isLoadedDialog: boolean, zoningCode: ZoningCode) => void;

    @Input()
    setIsLoadedHandler: (isLoaded: boolean) => void;

    @Input()
    showCalcButton?: boolean;

    @Input()
    showReCalcButton?: boolean;

    @Input()
    showCheckStatusButton?: boolean;

    @Input()
    showDeleteButton?: boolean;

    @Input()
    showSetLastUpdateButton?: boolean;

    @Input()
    stateEnv?: string;

    zoningCodeVersionCells: ITableCell[] = [
        { property: 'Id', title: 'Version Id' },
        { property: 'ActualVersion', title: 'Actual Version' },
        { property: 'PRCalculationResultsCount', title: 'Calculated Property Records' }
    ];

    zoningCodeVersionColumnsToDisplay: string[] = [
        ...this.zoningCodeVersionCells.map(zcvCell => zcvCell.property),
        'MissedEntities'
    ];

    constructor() {}

    ngOnInit(): void {
        if (this.showActions) {
            this.zoningCodeVersionColumnsToDisplay.push('Actions');
        }
        if (this.showStatusColumn) {
            this.zoningCodeVersionColumnsToDisplay.push('Status');
        }
    }

    openZCVersionSideNav(zoningCode: ZoningCode, zoningCodeVersion: ZoningCodeVersion) {
        if (this.zoningCodeVersionSelectionHandler) {
            this.zoningCodeVersionSelectionHandler(zoningCode, zoningCodeVersion);
        }
    }

    setIsLoadedZCVersionDialog(isLoadedDialog: boolean, zoningCode: ZoningCode) {
        if (this.setIsLoadedZCVersionDialogHandler) {
            this.setIsLoadedZCVersionDialogHandler(isLoadedDialog, zoningCode);
        }
    }

    setIsLoaded(isLoaded: boolean): void {
        if (this.setIsLoadedHandler) {
            this.setIsLoadedHandler(isLoaded);
        }
    }
}
